/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-webpack-loader-syntax */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { setZonesCategories } from 'store/actions/map/zoneCategories';
import ZonesWorkerFile from './workers/zones.worker';
import StatusesWorkerFile from './workers/statuses.worker';
import MappingTableWorkerFile from './workers/mappingTable.worker';
import RefreshTokenWorerFile from './workers/token.worker';
import LocalZonesWorkerFile from './workers/localZones.worker';
import ZonesCategoriesWorkerFile from './workers/zonesCategories.worker';
import {
  setAllZones,
  setAllLocalZones,
} from '../../store/actions/map/allZones';
import { addAlert } from '../../store/actions/alert/alerts';
import UserSessionDataHandler from '../../auth/UserSessionsDataHandler';
import { setDashboardSelectedOperationsApprovals } from '../../store/actions/dashboard/selectedOperationsApprovals';
import {
  operationsApprovalsInterval,
  missionsApprovalsGetterInterval,
} from '../../consts/config';
import { setApprovedAreas } from '../../store/actions/map/approvedAreas';
import { mappingTableParser, setNewTokenInUserConf } from './mapUtils';
import { setMappingUavos } from '../../store/actions/map/mappingUavos';
import history from '../../history';
import Auth from '../../auth/Auth';
import {
  getPrivateZonesFromAllZoneObjects,
  getCorridorsFromAllZoneObjects,
} from '../zones/utils/zoneDetailsUtils';

// const languageFromSettings = UserDataSessionHandler.getFromUserSettingsObjectInStore(
//   UserDataSessionHandler.defaultLanguage
// );
// if (languageFromSettings) dispatch(setLanguage(languageFromSettings));

const FetchData = () => {
  const dispatch = useDispatch();
  const language = useSelector(state => state.language);

  const zonesWorker = React.useRef(new ZonesWorkerFile());
  const zonesCategoriesWorker = React.useRef(new ZonesCategoriesWorkerFile());
  const statusesWorker = React.useRef(new StatusesWorkerFile());
  const mappingTableWorker = React.useRef(new MappingTableWorkerFile());
  const refreshTokenWorker = React.useRef(new RefreshTokenWorerFile());
  const localZonesTokenWorker = React.useRef(new LocalZonesWorkerFile());

  const getToken = () => UserSessionDataHandler.getToken();
  const getRefreshToken = () => UserSessionDataHandler.getRefreshToken();

  const unauthenticate = () => {
    const auth = new Auth();
    auth.unauthenticate();
    history.push('/');
  };

  React.useEffect(() => {
    zonesWorker.current.addEventListener('message', handleZones, false);
    zonesWorker.current.postMessage(getToken());

    zonesCategoriesWorker.current.addEventListener(
      'message',
      handleZonesCategories,
      false
    );
    zonesCategoriesWorker.current.postMessage(getToken());

    statusesWorker.current.addEventListener('message', handleStatuses, false);
    statusesWorker.current.postMessage(getToken());

    mappingTableWorker.current.addEventListener('message', handleTable);
    mappingTableWorker.current.postMessage(getToken());

    localZonesTokenWorker.current.addEventListener('message', handleLocalZones);
    localZonesTokenWorker.current.postMessage(getToken());

    refreshTokenWorker.current.addEventListener('message', handleToken);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const operationsApprovalsIntervalId = setInterval(
      runOperationsStatusesInterval,
      operationsApprovalsInterval
    );

    const tokenIntervalId = setInterval(
      runTokenInterval,
      missionsApprovalsGetterInterval
    );

    return () => {
      clearInterval(tokenIntervalId);
      clearInterval(operationsApprovalsIntervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleZones = event => {
    if (event.data.data)
      dispatch(setAllZones(_.groupBy(event.data.data, 'type')));
    else
      dispatch(
        addAlert({
          title: language.alerts.requestError.title_,
          desc: language.alerts.requestError.desc_,
          type: 'error',
        })
      );
  };

  const handleZonesCategories = event => {
    if (event.data.status === 200) {
      dispatch(setZonesCategories(event.data.data));
    } else
      dispatch(
        addAlert({
          title: language.alerts[event.data?.data?.code]?.title_,
          desc: language.alerts[event.data?.data?.code]?.desc_,
          type: 'error',
        })
      );
  };

  const handleLocalZones = event => {
    if (event.data.status === 200) {
      dispatch(
        setAllLocalZones(getPrivateZonesFromAllZoneObjects(event.data.data))
      );
      dispatch(
        setApprovedAreas(getCorridorsFromAllZoneObjects(event.data.data))
      );
    } else
      dispatch(
        addAlert({
          title: language.alerts.requestError.title_,
          desc: language.alerts.requestError.desc_,
          type: 'error',
        })
      );
  };

  const handleStatuses = event => {
    if (event.data.status === 200)
      dispatch(setDashboardSelectedOperationsApprovals(event.data.data));
    else if (event.data.status === 401) unauthenticate();
    else
      dispatch(
        addAlert({
          title: language.alerts.requestError.title_,
          desc: language.alerts.requestError.desc_,
          type: 'error',
        })
      );
  };

  const handleTable = event => {
    if (event?.data?.status === 200) {
      const parsedObj = mappingTableParser(event.data.data);
      dispatch(setMappingUavos(parsedObj));
    } else if (event?.data?.status === 401) unauthenticate();
    else
      dispatch(
        addAlert({
          title: language.alerts.requestError.title_,
          desc: language.alerts.requestError.desc_,
          type: 'error',
        })
      );
  };

  const handleToken = event => {
    if (event.data.status === 200) setNewTokenInUserConf(event.data.data);
    else if (event.data.status === 401) unauthenticate();
    else
      dispatch(
        addAlert({
          title: language.alerts.requestError.title_,
          desc: language.alerts.requestError.desc_,
          type: 'error',
        })
      );
  };

  const runOperationsStatusesInterval = () => {
    statusesWorker.current.postMessage(getToken());
  };

  const runTokenInterval = () => {
    refreshTokenWorker.current.postMessage({
      token: getToken(),
      refreshToken: getRefreshToken(),
    });
  };

  return null;
};

export default React.memo(FetchData);
